module.exports = __webpack_public_path__ + "img/certif_018.88fed810.jpg";